var $ba796dd79114e2d4$exports = {};
$ba796dd79114e2d4$exports = {
    "(optional)": `(opciono)`,
    "(required)": `(obavezno)`
};


export {$ba796dd79114e2d4$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
